export enum FEATURE_FLAGS {
  PEN_UPLOAD = "PEN_UPLOAD",
  TREATMENT_LIST = "TREATMENT_LIST",
  ROUTE_SESSION_LIST = "ROUTE_SESSION_LIST",
  AUDIT_RECORDS_LIST = "AUDIT_RECORDS_LIST",
}
